module.exports = __webpack_public_path__ + "img/module-title_red.dbd5b0ed.jpg";